import { InjectionToken } from '@angular/core';

export const SPECIFIC_WORKSPACE_ID = new InjectionToken<string>('SpecificWorkspaceId');
export const SPECIFIC_EVENT_NAME = new InjectionToken<string>('SpecificEventName');
